import { AdminAccountsOverview } from '@activepieces/shared';

type SeriesPoint = AdminAccountsOverview['series'][number];

const MONTH_KEY_LENGTH = 'YYYY-MM'.length;

// Periods are first-of-month dates ("2026-09-01"). The latest one is not always
// the current month — the indicators job runs at 04:00 — so the cut is made on
// the calendar month, in UTC like the periods themselves.
export const closedMonths = (
  series: SeriesPoint[],
  now: Date,
): SeriesPoint[] => {
  const currentMonth = now.toISOString().slice(0, MONTH_KEY_LENGTH);
  return series.filter(
    (point) => point.period.slice(0, MONTH_KEY_LENGTH) < currentMonth,
  );
};
